<div class="expanded-detail"
  [@detailExpand]="show ? 'expanded' : 'collapsed'">
  <div class="left">
    <h4>Anterior à edição</h4>
    <app-material-generic-table
      [dataSource]="data.originalData"
      [columnsDefinition]="columnDefinition"
      [displayedColumns]="displayedColumns"
      [emptyDataMessage]="'Nenhum valor original'"
      >
    </app-material-generic-table>
  </div>
  <mat-divider vertical></mat-divider>
  <div class="right">
    <h4>Após a edição</h4>
    <app-material-generic-table
      [dataSource]="data.editedData"
      [columnsDefinition]="columnDefinition"
      [displayedColumns]="displayedColumns"
      [emptyDataMessage]="'Nenhum valor editado'"
      >
    </app-material-generic-table>
  </div>
</div> 